module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['header', {
      'header-bg': !_vm.gradual
    }, _vm.headerClass],
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "header-nav"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://yiqijian.com",
      "title": "免费视频剪辑 - 一起剪"
    }
  }, [_vm._v("\n        免费视频剪辑\n        "), _c('SvgIcon', {
    staticClass: "icon-hot",
    attrs: {
      "name": "icon-hot"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('Dropdown', [_c('a', {
    staticClass: "nav-label",
    attrs: {
      "href": "javascript:void(0)",
      "title": "产品"
    }
  }, [_vm._v("\n            产品\n            "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-list product",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_vm._l((_vm.productList), function(item) {
    return [_c('a', {
      key: item.id,
      staticClass: "dropdown-item",
      attrs: {
        "href": item.value,
        "title": item.label,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])]
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('Dropdown', [_c('a', {
    staticClass: "nav-label",
    attrs: {
      "href": "javascript:void(0)",
      "title": "合作"
    }
  }, [_vm._v("\n            合作\n            "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_vm._l((_vm.serviceList), function(item) {
    return [_c('a', {
      key: item.id,
      staticClass: "dropdown-item",
      attrs: {
        "href": item.value,
        "title": item.label,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])]
  })], 2)])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search-box"
  }, [_c('SearchInput', {
    attrs: {
      "prefix": "ios-search",
      "value": _vm.searchValue,
      "openHistory": ""
    },
    on: {
      "change": _vm.handleChangeSearch,
      "search": _vm.handleSearch
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "right"
  }, [(false) ? _c('a', {
    staticClass: "reset-btn login",
    attrs: {
      "href": "//mp.yiqijian.com",
      "title": "一起剪"
    }
  }, [_vm._v("\n      登录\n    ")]) : _vm._e(), _vm._v(" "), (false) ? _c('a', {
    staticClass: "reset-btn register",
    attrs: {
      "href": "//account.yiqijian.com/auth/register?referer=https%3A%2F%2Fmp.yiqijian.com%2Fdashboard",
      "title": "一起剪"
    }
  }, [_vm._v("\n      注册\n    ")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/",
      "title": "一起剪"
    }
  }, [_c('h1', {
    attrs: {
      "title": "一起剪"
    }
  }, [_vm._v("一起剪")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307f53ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/yiqijian-video/components/Header/index.vue
// module id = 49
// module chunks = 1 2 3 4 5